/**
 * Google AdSense configuration. Client script is loaded in public/index.html.
 * Create ad units in AdSense and set slot IDs via env for each placement (optional).
 * If a slot is not set, the GoogleAd component will not render that placement.
 *
 * Env vars (optional):
 *   REACT_APP_GOOGLE_ADS_CLIENT  – Publisher ID (default: from index.html)
 *   REACT_APP_GOOGLE_ADS_SLOT   – Default slot ID used when placement-specific slot is unset
 *   REACT_APP_GOOGLE_ADS_SLOT_BANNER   – Main banner (Landing, Dashboard, Leaderboard, etc.)
 *   REACT_APP_GOOGLE_ADS_SLOT_SIDEBAR  – Sidebar (left nav, app layout)
 *   REACT_APP_GOOGLE_ADS_SLOT_IN_FEED  – In-feed (HomeFeed between items)
 *   REACT_APP_GOOGLE_ADS_SLOT_RECTANGLE – Medium rectangle
 */

const AD_CLIENT = process.env.REACT_APP_GOOGLE_ADS_CLIENT || 'ca-pub-4246086514817188';

/** Slot IDs per placement. Set REACT_APP_GOOGLE_ADS_SLOT_* in .env for production. */
export const AD_SLOTS = {
  /** Main banner (Landing, Dashboard, Leaderboard, etc.) */
  BANNER: process.env.REACT_APP_GOOGLE_ADS_SLOT_BANNER || process.env.REACT_APP_GOOGLE_ADS_SLOT || '',
  /** Sidebar / in-app layout */
  SIDEBAR: process.env.REACT_APP_GOOGLE_ADS_SLOT_SIDEBAR || process.env.REACT_APP_GOOGLE_ADS_SLOT || '',
  /** In-feed (HomeFeed between items) */
  IN_FEED: process.env.REACT_APP_GOOGLE_ADS_SLOT_IN_FEED || process.env.REACT_APP_GOOGLE_ADS_SLOT || '',
  /** Rectangle / medium rectangle */
  RECTANGLE: process.env.REACT_APP_GOOGLE_ADS_SLOT_RECTANGLE || process.env.REACT_APP_GOOGLE_ADS_SLOT || '',
};

export function getAdClient() {
  return AD_CLIENT;
}

export function hasAdSlot(slotKey) {
  const slot = AD_SLOTS[slotKey] || AD_SLOTS.BANNER;
  return typeof slot === 'string' && slot.trim().length > 0;
}

export function getAdSlot(slotKey = 'BANNER') {
  return AD_SLOTS[slotKey] || AD_SLOTS.BANNER || '';
}
